export const VISUAL_TRACKING_CONFIG_CHANGED_EVENT =
  'visual-tracking-config-changed';

export function notifyVisualTrackingConfigChanged(): void {
  if (typeof window === 'undefined') {
    return;
  }
  window.dispatchEvent(new Event(VISUAL_TRACKING_CONFIG_CHANGED_EVENT));
}
